
/**
 * Awaitable version of setTimeout
 *
 * @example
 * await timeout(10)
 * await timeout() // wait till the next event loop tick
 */
export function timeout(ms?: number, opts: { signal?: AbortSignal } = { }): Promise<void> {
    return new Promise((resolve) => {
        const timeout = setTimeout(resolve, ms);
        if (opts.signal) {
            opts.signal.addEventListener("abort", () => {
                clearTimeout(timeout);
                resolve();
            });
        }
    });
}
